import React, { useRef } from "react"
import { handleUpdateBandData } from "../BandEditPage"
import { Band, BandType as BandTypeEnum } from "../../types/bands"
import { useBandEditForm } from "./BandEditFormContext"

export const BAND_TYPE_LABELS: Record<BandTypeEnum, string> = {
  band: "Band",
  individual: "Musician",
  venue: "Venue",
  blog: "Blog",
  promoter: "Promoter",
  fan: "Fan",
}

interface BandTypeProps {
  band: Band
}

export const BandType: React.FC<BandTypeProps> = ({ band }) => {
  const { form } = useBandEditForm()
  const bandType = form.watch("band_type") as BandTypeEnum
  const wasFan = useRef(band.band_type === "fan")

  const handleBandTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newBandType = event.target.value as BandTypeEnum
    form.setValue("band_type", newBandType)
    handleUpdateBandData(band.id, { band_type: newBandType })
  }

  const showUpgradePrompt = wasFan.current && bandType !== "fan"

  return (
    <>
      <div className="mt-10">
        <label
          className="block col-span-12 text-gray-900 text-xs uppercase font-bold"
          htmlFor="bandType"
        >
          What Best Describes You?
        </label>
        <div className="mt-2">
          <label className="lg:inline-flex block items-center lg:mr-6">
            <input
              type="radio"
              className="form-radio"
              name="band_type"
              value="band"
              checked={bandType === "band"}
              onChange={handleBandTypeChange}
            />
            <span className="ml-2 text-gray-700">Band</span>
          </label>
          <label className="lg:inline-flex block items-center lg:mr-6">
            <input
              type="radio"
              className="form-radio"
              name="band_type"
              value="individual"
              checked={bandType === "individual"}
              onChange={handleBandTypeChange}
            />
            <span className="ml-2 text-gray-700">Musician</span>
          </label>
          <label className="lg:inline-flex block items-center lg:mr-6">
            <input
              type="radio"
              className="form-radio"
              name="band_type"
              value="venue"
              checked={bandType === "venue"}
              onChange={handleBandTypeChange}
            />
            <span className="ml-2 text-gray-700">Venue</span>
          </label>
          <label className="lg:inline-flex block items-center lg:mr-6">
            <input
              type="radio"
              className="form-radio"
              name="band_type"
              value="blog"
              checked={bandType === "blog"}
              onChange={handleBandTypeChange}
            />
            <span className="ml-2 text-gray-700">Blog</span>
          </label>
          <label className="lg:inline-flex block items-center lg:mr-6">
            <input
              type="radio"
              className="form-radio"
              name="band_type"
              value="promoter"
              checked={bandType === "promoter"}
              onChange={handleBandTypeChange}
            />
            <span className="ml-2 text-gray-700">Promoter</span>
          </label>
          <label className="lg:inline-flex block items-center">
            <input
              type="radio"
              className="form-radio"
              name="band_type"
              value="fan"
              checked={bandType === "fan"}
              onChange={handleBandTypeChange}
            />
            <span className="ml-2 text-gray-700">Fan</span>
          </label>
        </div>
        <div className="text-xs text-gray-500">
          don't worry, you can change this anytime
        </div>
        <div
          className={`overflow-hidden transition-all duration-300 ease-in-out ${showUpgradePrompt ? "max-h-20 mt-3 opacity-100" : "max-h-0 opacity-0"}`}
        >
          <p className="text-sm text-green-700">
            Glad you're on board as a {BAND_TYPE_LABELS[bandType]}!{" "}
            <a href={band.edit_band_path} className="underline font-semibold text-blue-700">
              Let's setup your {BAND_TYPE_LABELS[bandType]} page now.
            </a>
          </p>
        </div>
      </div>
    </>
  )
}
